// src/redux/store.js

import { configureStore } from '@reduxjs/toolkit';
import wishlistReducer from './wishlistSlice';
import cartReducer from './cartSlice';
import authReducer from './authSlice';
import locationReducer from './locationSlice';

const store = configureStore({
  reducer: {
    wishlist: wishlistReducer, // Include wishlistReducer in the store
    cart: cartReducer,
    auth: authReducer,
    location: locationReducer,
  },
});

export default store;
